import type { Node as ProseMirrorNode } from '@tiptap/pm/model';

import { TiptapNodeType } from '../../tiptapTypes';

export type ChildTaskList = {
    node: ProseMirrorNode;
    /** The task list's offset within its parent node's content. */
    offset: number;
};

/**
 * Gets the task list held by a node, along with its offset - the nested list holding a task item's
 * sub-tasks, or the document's own list.
 */
export const getChildTaskList = (node: ProseMirrorNode): ChildTaskList | null => {
    let childTaskList: ChildTaskList | null = null;

    node.forEach((child, offset) => {
        if (child.type.name === TiptapNodeType.taskList) childTaskList = { node: child, offset };
    });

    return childTaskList;
};
